// @flow
import React from 'react';

import RowLayout, { Header } from 'app/common/layouts/RowLayout';


const Options = () => (
  <React.Fragment>
    <RowLayout>
      <Header>{'Настройки'}</Header>
    </RowLayout>
    <RowLayout>
      {'...'}
    </RowLayout>
  </React.Fragment>
);

export default Options;
